import React, { useEffect, useRef, useState } from "react";
import { CloseOutlined, CommentOutlined } from "@ant-design/icons";
import { Input, Tag } from "antd";
import { defaultSettings } from "css/defaultAntStyles";
const { TextArea } = Input;
const MyTagComment = ({ children, item, changeComment, disabled = false }) => {
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState(item.comment || "");

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);
  const showInput = () => {
    setInputVisible(true);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputConfirm = () => {
    // inputValue - коментар для роботи чи матеріалу
    changeComment({
      typeContent: item.allowedWorkTypeId ? "work" : "material",
      param: item.allowedWorkTypeId || item.id,
      comment: inputValue,
    });
    setInputVisible(false);
  };

  return (
    <>
      {inputVisible ? (
        <div
          style={{
            position: "relative",
            width: "100%",
          }}
        >
          <TextArea
            autoSize={{ minRows: 2, maxRows: 10 }}
            ref={inputRef}
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleInputConfirm}
            placeholder="Залиште коментар..."
            style={{
              padding: "8px 22px 8px 8px",
            }}
            disabled={disabled}
          />
          <CloseOutlined
            onClick={() => {
              handleInputConfirm();
            }}
            style={{
              color: defaultSettings.colorPrimary,
              position: "absolute",
              top: 8,
              right: 8,
              cursor: "pointer",
              fontSize: 18,
              opacity: 0.7,
            }}
          />
        </div>
      ) : (
        <div
          onClick={showInput}
          style={{
            display: "flex",
            gap: 7,
            width: "100%",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 12,
              width: "100%",
            }}
          >
            {children}
          </div>
          <>
            {item.comment ? (
              <Tag
                icon={<CommentOutlined />}
                color="default"
                style={{
                  whiteSpace: "normal",
                  height: "auto",
                  lineHeight: "22px",
                  wordBreak: "break-word",
                  marginLeft: "auto",
                  marginRight: 0,
                  maxWidth: "calc(100% - 100px)",
                }}
              >
                {item.comment}
              </Tag>
            ) : (
              ""
            )}
          </>
        </div>
      )}
    </>
  );
};
export default MyTagComment;
